import React from 'react';

const BadgeStatus = ({ text, status }) => {
    // Define styles for different statuses
    const statusStyles = {
        success: 'bg-green-100 text-green-800',
        approved: 'bg-green-100 text-green-800',
        warning: 'bg-yellow-100 text-yellow-800',
        error: 'bg-red-100 text-red-800',
        info: 'bg-blue-100 text-blue-800',
        signed: 'bg-blue-100 text-blue-800',
        default: 'bg-gray-100 text-gray-800',
    };

    return (
        <span
            className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${statusStyles[status] || statusStyles.default}`}
        >
            {text}
        </span>
    );
};

export default BadgeStatus;
